export function shuffle(words: string[]) {
    const shuffled = [...words];
    shuffled.sort((_left, _right) => {
        return 0.5 - Math.random();
    });

    return shuffled;
}